/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useRef, useMemo, useEffect, useState } from "react";
/* eslint-enable @typescript-eslint/no-unused-vars */
// antd:
import { Button } from "antd";

// My Components:
import AppIcons from "./AppIcons.tsx";
import DivE from "./DivE.tsx";
import MainMenuSection from "./MainMenuSection.tsx";
// Redux-hooks:
import { useAppSelector } from "../../libs/redux-hooks.ts";
// Reducers:
import { getMenuApps, getDict, getDesktopType, getConfig } from "../../libs/reducer.ts";
// Types
import type {TappSection} from "../../types/uiapp.d.ts";

const { rz, $ } = window;

type componentProps = {closePortal:(e:React.MouseEvent) => void};
const MainMenuContent:FC<componentProps> = ({closePortal}) => {
  const dct = useAppSelector(getDict);
  const isMobile = useAppSelector(getDesktopType);
  const menuApps = useAppSelector(getMenuApps);
  const cfg = useAppSelector(getConfig);

  const toolbarRef = useRef(null);

  const stl1 = useMemo<{[key:string]:any}>(() => ({
    backgroundImage: "url('" + (cfg?.personalsettings?.find((rec) => (rec.key === "mainMenuBgImage"))?.value || "") + "')",
    backgroundColor: "rgba(70,70,70,100)", backgroundBlendMode: "multiply",
    OBackgroundSize: "cover", MozBackgroundSize: "cover", WebkitBackgroundSize: "cover", backgroundPosition: "center center",
    width: window.innerWidth, height: window.innerHeight, top: "0%", left: "0%", position: "absolute", zIndex: 600
  }), [cfg?.personalsettings]);

  const [sectionsState, setSectionsState] = useState<{key:string; expanded:boolean;}[]>([]);

  useEffect(() => {
    setSectionsState(menuApps.map((ss:TappSection) => ({key: ss.key, expanded: Boolean(ss.expanded)})));
  }, [menuApps]);

  const closeAllContainers = (e?:React.MouseEvent) => {
    if (!e || !e.target) return;
    const elId = $(e.target).attr("id");
    if (!elId || !rz.arrContains(["main-menu-content", "main-menu-grid", "layout-mainmenu-toolbar", "layout-mainmenu-nav"], elId)) return;
    setSectionsState(menuApps.map((ss) => ({key: ss.key, expanded: false})));
  };

  const toogleOneContainer = (key:string) => {
    const eIndex = rz.arrFindObj(sectionsState, {key});
    setSectionsState(sectionsState.map((ss, s) => ({key: ss.key, expanded: (~eIndex && s === eIndex ? !ss.expanded : false)})));
  };

  const allSections = menuApps.map((ss:TappSection) => {
    const eIndex = rz.arrFindObj(sectionsState, {key: ss.key});
    return (<MainMenuSection key={ss.key} section={ss} isExpanded={Boolean(~eIndex && sectionsState[eIndex].expanded)} onToogle={toogleOneContainer} onAppClick={closePortal} />)
  });

  return (
    <div className="homepage-bgimage uk-height-viewport uk-background-fixed uk-background-cover uk-background-center" onClick={(e) => { closeAllContainers(e) }} style={stl1}>
      <div ref={toolbarRef} id="layout-mainmenu-toolbar" className="uk-position-top uk-margin-remove" onClick={(e) => { closeAllContainers(e) }}>
        <nav id="layout-mainmenu-nav"
          className="uk-navbar uk-navbar-transparent uk-navbar-container uk-margin-remove uk-flex uk-flex-row uk-flex-nowrap rz-padding-5"
          onClick={(e) => { closeAllContainers(e) }}
        >
          <div className="uk-navbar-right">
            <div className="uk-navbar-item uk-padding-remove rz-margin-right-10">
              <Button type="primary" size={isMobile ? undefined : "large"} icon={<AppIcons icopath="ai/AiOutlineClose" attrs={{}} />} onClick={closePortal} uk-tooltip={dct.p.buttonclose} />
            </div>
          </div>
        </nav>
      </div>
      <div id="main-menu-content"
        className="uk-container-expand uk-position-relative"
        onClick={(e) => { closeAllContainers(e) }}
        // @ts-ignore
        style={{height: (window.innerHeight) - (toolbarRef?.current?.offsetHeight || 40), width: "100%", marginTop: (toolbarRef?.current?.offsetHeight || 40)}}
      >
          <DivE id="main-menu-grid"
            className="uk-grid uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l uk-child-width-1-4@xl"
            uk-grid="masonry: true"
            style={{height: "100%"}}
          >
              {menuApps.length ? allSections : <div key="no-menu-sections"/>}
          </DivE>
        </div>
    </div>
  );
}

export default MainMenuContent;
